import { crv, cva } from '@/styled-system/css';

export const paginationItemStyles = cva({
  base: {
    '&:has(>[data-c11n-component="Pagination.PageButton"])': {
      marginInlineStart: 'Pagination.Item.between-pages',
    },
    '[data-c11n-component="Pagination.Item"]:has(>[data-c11n-component="Pagination.PreviousButton"]) + &':
      {
        marginInlineStart: '0',
      },
    '&:has(>[data-c11n-component="Pagination.PreviousButton"])': {
      paddingInline: 'Pagination.JumpItem.padding.horz',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
      marginInlineEnd: 'Pagination.JumpItem.to-controls',
    },
    '&:has(>[data-c11n-component="Pagination.NextButton"])': {
      paddingInline: 'Pagination.JumpItem.padding.horz',
      paddingBlock: 'Pagination.JumpItem.padding.vert',
      marginInlineStart: 'Pagination.JumpItem.to-controls',
    },
  },
  variants: {
    ...crv('showNumberButtons', {
      true: {
        '&:has(>[data-c11n-component="Pagination.PageButton"])': {
          display: 'block',
        },
      },
      false: {
        '&:has(>[data-c11n-component="Pagination.PageButton"])': {
          display: 'none',
        },
      },
    }),
  },
});
